export default {
  BACKEND_UNAVAILABLE:
    'We are currently experiencing technical difficulties. Please try again later.',
  EMAIL_ADDRESS_INVALID: '',
  LOGIN_ERROR:
    "Hmm, we don't recognize that email or you mistyped your password. Please try again.",
  EMAIL_ADDRESS_UNCONFIRMED:
    "Your email address isn't confirmed yet, the confirmation email has been resend to your email address",
  EMAIL_ADDRESS_UNCONFIRMED_FAILED_RESEND:
    "Your email address isn't confirmed yet, failed to resend the confirmation email",
  EMAIL_CONFIRMATION_INVALID: 'Cannot confirm your email address: email or validation id invalid',
  EMAIL_CONFIRMATION_ALREADY_CONFIRMED: 'Account already activated',
  CREATE_ACCOUNT_FAILED: 'We are unable to create your account due to validation errors',
  CREATE_ACCOUNT_EXISTS: 'An account with that name already exists, try resetting your password',
  PROFILE_FETCH_FAILED: 'We are unable to retrieve your profile',
  RESET_ERROR: 'Unable to locate account for your email address',
  CHANGE_PASSWORD_FAILED: 'We are unable to change your password at this moment',
  ACCOUNT_DELETION_FAILED: 'We are unable to delete your account at this moment',
  PASSWORD_COMPLEXITY: 'The password must contain at least one digit and one uppercase letter'
}
